if (!window.Eurus.loadedScript.has('map.js')) {
  window.Eurus.loadedScript.add('map.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xMap", (data) => ({
        mapSrc(value) {
          var v = String(value || '').trim();
          // A Google Business listing link (maps?cid=...) points at the exact
          // listing, so it needs no coordinates and cannot be mis-searched.
          var m = v.match(/[?&]cid=(\d+)/);
          if (m) return 'https://maps.google.com/maps?cid=' + m[1] + '&output=embed';
          var q = null;
          // /maps/place/Name/@56.9496,24.1052,17z
          m = v.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
          if (m) q = m[1] + ',' + m[2];
          // ...!3d56.9496!4d24.1052
          if (!q) { m = v.match(/!3d(-?\d+\.\d+)!4d(-?\d+\.\d+)/); if (m) q = m[1] + ',' + m[2]; }
          // ?q=<address or lat,lng>
          if (!q) { m = v.match(/[?&]q=([^&]+)/); if (m) q = decodeURIComponent(m[1].replace(/\+/g, ' ')); }
          // not a link at all - the address keyword, as before
          if (!q) q = v;
          return 'https://maps.google.com/maps?q=' + encodeURIComponent(q) + '&t=m&z=17&ie=UTF8&output=embed&iwloc=near';
        },
        load() {
          this.$el.querySelector(
            "iframe"
          ).src = this.mapSrc(data);
        },
        loadMap(location) {
          this.$el.querySelector(
            "iframe"
          ).src = this.mapSrc(location);
        },
        removeMap() {
          this.$el.querySelector(
            "iframe"
          ).src = ``;
        } 
      }));
    });
  });
}